import { render, staticRenderFns } from "./Pharma.vue?vue&type=template&id=4754ea01&scoped=true&"
import script from "./Pharma.vue?vue&type=script&lang=js&"
export * from "./Pharma.vue?vue&type=script&lang=js&"
import style0 from "./Pharma.vue?vue&type=style&index=0&id=4754ea01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754ea01",
  null
  
)

export default component.exports